/* eslint-disable import/prefer-default-export */
import * as ReduxHelpers from '@src/utils/reduxHelpers'
const prefix = 'cam/policies'

export const GET_POLICIES_SUCCESS = ReduxHelpers.Types.createActionType(
  prefix,
  'GET_POLICIES_SUCCESS'
)
export const SET_SELECTED_POLICY = ReduxHelpers.Types.createActionType(
  prefix,
  'SET_SELECTED_POLICY'
)
export const SERVER_ERRORS = ReduxHelpers.Types.createActionType(
  prefix,
  'SERVER_ERRORS'
)
export const REQUEST_PENDING = ReduxHelpers.Types.createActionType(
  prefix,
  'REQUEST_PENDING'
)
